import { BookingState } from './BookingState';
import { mapObject } from '../../utils/MapUtils';
import { Brand, ContactMethodType, Title } from '../entities/Entities';
import { formatDate, parseDate } from '../../utils/DateUtils';
import { BookingStorage } from '../booking-storage/BookingStorage';
import { bookingStorageVersion } from '../booking-storage/BookingStorageVersion';

export class BookingStateMapper {
  static MapBookingStateToBookingStorage(state: BookingState): BookingStorage {
    return {
      ...state,
      storageVersion: bookingStorageVersion,
      createdBooking: mapObject(state.createdBooking),
      vehicleServiceHistory: mapObject(state.vehicleServiceHistory, (x) => ({
        ...x,
        serviceDate: formatDate(x.serviceDate),
      })),
      vehicleDetails: mapObject(state.vehicleDetails, (x) => ({
        ...x,
        plans: x.plans?.map(plan => ({
          ...plan,
          planStartDate: plan.planStartDate ? formatDate(plan.planStartDate) : null,
          planEndDate: plan.planEndDate ? formatDate(plan.planEndDate) : null,
        })) || [],
      })),
      tcosEstimation: mapObject(state.tcosEstimation),
      serviceRequest: mapObject(state.serviceRequest),
      selectedSlot: mapObject(state.selectedSlot, (x) => ({
        ...x,
        date: formatDate(x.date),
      })),
      selectedDealer: mapObject(state.selectedDealer),
      customerContact: mapObject(state.customerContact),
    };
  }

  static MapBookingStorageToBookingState(value: BookingStorage): BookingState {
    const { storageVersion, ...rest } = value;
    const state = {
      ...rest,
      customerContact: mapObject(value.customerContact, (x) => ({
        ...x,
        title: x.title as Title,
        preferredContactMethodType: x.preferredContactMethodType as ContactMethodType,
      })),
      selectedSlot: mapObject(value.selectedSlot, (x) => ({
        ...x,
        date: parseDate(x.date),
      })),
      serviceRequest: mapObject(value.serviceRequest),
      tcosEstimation: mapObject(value.tcosEstimation),
      vehicleDetails: mapObject(value.vehicleDetails, (x) => ({
        ...x,
        title: x.title as Title,
        brand: x.brand as Brand,
        plans: x.plans?.map(plan => ({
          ...plan,
          planStartDate: plan.planStartDate ? parseDate(plan.planStartDate) : null,
          planEndDate: plan.planEndDate ? parseDate(plan.planEndDate) : null,
        })) || [],
      })),
      vehicleServiceHistory: mapObject(value.vehicleServiceHistory, (x) => ({
        ...x,
        serviceDate: parseDate(x.serviceDate),
      })),
      createdBooking: mapObject(value.createdBooking),
      selectedDealer: mapObject(value.selectedDealer),
    };

    return state;
  }
}
